import Vue from 'vue';
import {
    GET_INDEX_ARTICLES_REQUEST,
    GET_INDEX_ARTICLES_SUCCESS,
    GET_INDEX_ARTICLES_FAILURE,
    GET_INDEX_ORDER_COUNT_REQUEST,
    GET_INDEX_ORDER_COUNT_SUCCESS,
    GET_INDEX_ORDER_COUNT_FAILURE,
    GET_INDEX_NOTICE_REQUEST,
    GET_INDEX_NOTICE_SUCCESS,
    GET_INDEX_NOTICE_FAILURE,
    GET_PREDICT_COUNT_REQUEST,
    GET_PREDICT_COUNT_SUCCESS,
    GET_PREDICT_COUNT_FAILURE,
    UPDATE_PREDICT_SHOW
} from '../mutationTypes';

const state = {
    orderOpenning: 0,
    notpayCarOrder: 0,
    storeWarning: 0,
    orderCompleted: 0,
    activityArticle: [],
    announcement: [],
    noticeList: [],
    predictCount: {},
    predictShow: false,
    aStatus: {
        loading: false,
        errorType: ''
    },
    oStatus: {
        loading: false,
        errorType: '',
    },
    nStatus: {
        loading: false,
        errorType: '',
    },
    pStatus: {
        loading: false,
        errorType: '',
    },
};
const mutations = {
    [GET_INDEX_ARTICLES_REQUEST](state) {
        state.aStatus.loading = true;
    },
    [GET_INDEX_ARTICLES_SUCCESS](state, res) {
        state.aStatus.loading = false;

        state.announcement = res.announcement;
        state.activityArticle = res.activityArticle;
    },
    [GET_INDEX_ARTICLES_FAILURE](state, errorType) {
        state.aStatus.loading = false;
        state.aStatus.errorType = errorType;
    },
    [GET_INDEX_ORDER_COUNT_REQUEST](state) {
        state.oStatus.loading = true;
    },
    [GET_INDEX_ORDER_COUNT_SUCCESS](state, res) {
        state.oStatus.loading = false;

        state.orderOpenning = res.hangOrderNum;
        state.notpayCarOrder = res.notpayCarOrder;
        state.storeWarning = res.storeWarning;
        state.orderCompleted = res.completeOrderNum;
    },
    [GET_INDEX_ORDER_COUNT_FAILURE](state) {
        state.oStatus.loading = false;
    },
    [GET_INDEX_NOTICE_REQUEST](state) {
        state.nStatus.loading = true;
    },
    [GET_INDEX_NOTICE_SUCCESS](state, res) {
        state.nStatus.loading = false;
        state.noticeList = res.list;
    },
    [GET_INDEX_NOTICE_FAILURE](state) {
        state.nStatus.loading = false;
        state.noticeList = [];
    },
    [GET_PREDICT_COUNT_REQUEST](state) {
        state.pStatus.loading = true;
    },
    [GET_PREDICT_COUNT_SUCCESS](state, res) {
        state.pStatus.loading = false;
        state.predictCount = res;
        if (state.predictCount.predict_goods > 0) {
            state.predictShow = true;
        } else {
            state.predictShow = false;
        }
    },
    [UPDATE_PREDICT_SHOW](state, show) {
        state.predictShow = show;
    },
    [GET_PREDICT_COUNT_FAILURE](state) {
        state.pStatus.loading = false;
        state.predictCount = {};
        state.predictShow = false;
    }
};

export const actions = {
    async getIndexArticle({ commit }) {
        commit(GET_INDEX_ARTICLES_REQUEST);

        const res = await Vue.$ajax.get('getArticles');

        if (!res.errorType) {
            commit(GET_INDEX_ARTICLES_SUCCESS, res);
        } else {
            commit(GET_INDEX_ARTICLES_FAILURE, res.errorType);
        }
    },
    async getIndexOrderCount({ commit }) {
        commit(GET_INDEX_ORDER_COUNT_REQUEST);

        const res = await Vue.$ajax.get('indexOrderCount');

        if (!res.errorType) {
            commit(GET_INDEX_ORDER_COUNT_SUCCESS, res);
        } else {
            commit(GET_INDEX_ORDER_COUNT_FAILURE, res.errorType);
        }
    },
    async getIndexNotice({ commit }) {
        commit(GET_INDEX_NOTICE_REQUEST);
        const res = await Vue.$ajax.get('noticeList', {
            page: 1,
            pagesize: 5,
        });

        if (!res.errorType) {
            commit(GET_INDEX_NOTICE_SUCCESS, res);
        } else {
            commit(GET_INDEX_NOTICE_FAILURE);
        }
    },
    async getPredictCount({ commit }) {
        commit(GET_PREDICT_COUNT_REQUEST);
        const res = await Vue.$ajax.get('predictedMarketing');

        if (!res.errorType) {
            commit(GET_PREDICT_COUNT_SUCCESS, res);
        } else {
            commit(GET_PREDICT_COUNT_FAILURE);
        }
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/home.js